import * as lodash from 'lodash';
import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import OfficeExpenseUnitEntry from 'src/models/AP/OfficeExpenseUnit';
import DialogList from 'src/dialogs';
import OfficeExpenseUnit from 'src/models/AP/OfficeExpenseUnit';
import { FiTrash2 } from 'react-icons/fi';
import { FaPlusCircle } from 'react-icons/fa';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';

interface IOfficeExpenseUnitManagementDialogProps {
    dialogName: string;
    officeExpense: { expenseCategery: string, expenseValue: string};
    officeExpenseUnits: Array<OfficeExpenseUnit>;
    deleteOfficeExpenseUnit?: (unitId: number) => void; 
    onSubmit?: (payload: Array<OfficeExpenseUnit>) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const OfficeExpenseUnitManagementDialog = (props: IOfficeExpenseUnitManagementDialogProps) => {
    const [unitManagementExpenses, setUnitManagementExpenses] = useState<Array<OfficeExpenseUnitEntry>>(undefined);
    const { register, errors, getValues, reset, formState } = useForm();
    const { isDirty, dirtyFields } = formState;
    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(props?.officeExpenseUnits)) {
            setUnitManagementExpenses(props.officeExpenseUnits);
            reset({
                officeExpenseUnits: props.officeExpenseUnits
            });
        }
    }, [props?.officeExpenseUnits]);

    const onCreate = () => {
        console.log('OfficeExpenseUnitManagementDialog onCreate()');
    };

    const AddExpenseRow = () => {
        const newExpenseRow = new OfficeExpenseUnit();
        newExpenseRow.description  = props?.officeExpense?.expenseCategery;
        const tempExpenseRows  = lodash.cloneDeep(unitManagementExpenses);
        tempExpenseRows.push(newExpenseRow);
        setUnitManagementExpenses(tempExpenseRows);
    };

    const OKClicked = async () => {
        if (isDirty && dirtyFields && props.onSubmit) {
            const payload = getValues();

            const officeExpenseUnits =
                (payload.officeExpenseUnits as Array<OfficeExpenseUnit>).filter(
                    (_, index) => dirtyFields.officeExpenseUnits?.[index]?.amount
                );

            await props.onSubmit(officeExpenseUnits);

            reset(getValues());
        } else {
            props.hideDialog();
        }
    };

    const deleteExpenseUnit = async (unitId: number) => {
        setUnitManagementExpenses(prev =>
            prev.filter(expense => expense.id !== unitId)
        );

        await props?.deleteOfficeExpenseUnit(unitId);
    };

    const displayOfficeExpenseUnitEntries = () => {
        return (
            <>
                <table className={'project-billing'} style={{borderBottom: '1rem'}}>
                <thead className={'project-billing'}>
                    <th style={{width: '45%', border: 'solid black 1.5px', backgroundColor: '#89FA68'}}>Description</th>
                    <th style={{width: '45%', border: 'solid black 1.5px', backgroundColor: '#89FA68'}}>Amount</th>
                </thead>
                <tbody className={'project-billing'}>
                {Array.isArray(unitManagementExpenses) && unitManagementExpenses?.length > 0 && unitManagementExpenses.map(
                    (oe: OfficeExpenseUnit, index: number) => {
                        return (<tr key={oe.id + index.toString()}>                            
                                <td style={{width: '47%'}}>
                                    {props?.officeExpense?.expenseCategery !== 'Other' &&
                                    <RHFInputBox
                                        name={`officeExpenseUnits.${index}.description`}
                                        register={register}
                                        defaultVal={oe.description}
                                        errors={errors}
                                        readOnly={true}
                                    />}
                                    {props?.officeExpense?.expenseCategery === 'Other' &&
                                    <RHFTextArea
                                        name={`officeExpenseUnits.${index}.description`}
                                        register={register}
                                        defaultValue={oe.description}
                                        errors={errors}
                                        style={{width: '100%', height: '3rem', resize: 'none'}}
                                        maxLength={30}
                                    />}
                                </td>
                                <td style={{width: '38%'}}>
                                    <RHFInputBox
                                        name={`officeExpenseUnits.${index}.amount`}
                                        register={register}
                                        errors={errors}
                                        style={{textAlign: 'right'}}
                                    />
                                </td>
                                <td style={{width: '7%'}}>
                                    <Button
                                        style={{borderBottom: 'solid grey 1px', height: '3rem', background: 'white'}}
                                        text={''}
                                        title="Delete Expense"
                                        reactIcon={FiTrash2}
                                        iconHoverColor="blue"
                                        iconStyle={{transform: 'translateY(-6px)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                        onClick={() => deleteExpenseUnit(oe.id)}
                                    />
                                    <input
                                        type="hidden"
                                        name={`officeExpenseUnits.${index}.id`}
                                        value={oe?.id ? oe.id : undefined}
                                        ref={register}
                                    />
                                    <input
                                        type="hidden"
                                        name={`officeExpenseUnits.${index}.type`}
                                        value={props?.officeExpense?.expenseCategery}
                                        ref={register}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </>
        );
    };

    return (
        <Dialog title={`Manage ${props?.officeExpense?.expenseCategery} Expenses`} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <label style={{ marginBottom: '.5rem'}}>Expense Category: <b>{props?.officeExpense?.expenseCategery}</b></label>
                        {displayOfficeExpenseUnitEntries()}
                        <Button
                            className="blue-hover-button"
                            style={{ width: '20%', marginRight: '1rem' }}
                            reactIcon={FaPlusCircle}
                            title={'Add New Expense'}
                            text={'Add'}
                            iconHoverColor="blue"
                            iconStyle={{marginRight: '1rem', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                            onClick={() => AddExpenseRow()}
                        />
                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={isDirty ? 'Save Changes' : 'Exit'}
                            onClick={() => OKClicked()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default OfficeExpenseUnitManagementDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/OfficeExpenseUnitManagementDialog.tsx